import { CanvasBlockRenderer } from "../CanvasBlockRenderer";
import { type CanvasBlock } from "../types";

interface ListBlockProps {
  ordered: boolean;
  items: CanvasBlock[];
  onSectionClick?: (sectionId: string, title: string) => void;
  onBadgeAction?: (action: string, label: string) => void;
}

export function ListBlock({
  ordered,
  items,
  onSectionClick,
  onBadgeAction,
}: ListBlockProps) {
  const Tag = ordered ? "ol" : "ul";
  const listClass = ordered ? "list-decimal" : "list-disc";

  return (
    <Tag
      className={`${listClass} space-y-1 pl-5 text-sm text-puntt-neutral-gray-11`}
    >
      {(items ?? []).map((item, idx) => (
        <li key={idx}>
          <CanvasBlockRenderer
            block={item}
            onSectionClick={onSectionClick}
            onBadgeAction={onBadgeAction}
          />
        </li>
      ))}
    </Tag>
  );
}
